(function(){
  angular
       .module('irricrops')
  .controller("programaFertCtrl", 
      ['$mdDialog', 'menu', 'temporadaFac','$stateParams','global','$http','urls',
      function($mdDialog, menu, temporadaFac, $stateParams, global, $http, urls){

        var vm               = this;
        vm.temporadas        = [];
        vm.temporadaSelected = null;
        vm.programaSelected  = null;
        vm.loading           = true;
        vm.programas         = [];
        vm.productos         = [];
        vm.equipos           = [];

        vm.etapas = [];
        //programa > sectores > etapa > productos > value

        var vinedoId = $stateParams.id;

        var newProgramaTemplate = {
          id          : 0,
          nombre      : "programa nuevo",
          fechaInicio : "2021-01-01 00:00:00",
          fechaFin    : "2021-03-01 00:00:00",

          //datos de frontend
          isNew       : true,
          vinedoId    : vinedoId,
          sectores    : []
        };

        var newEtapaTemplate = {
          id          : 0,
          nombre      : "etapa nueva",
          fechaInicio : "2021-01-01 00:00:00",
          fechaFin    : "2021-03-01 00:00:00",

          //datos de server, se deben evaluar
          dias                       : 0,
          progreso                   : 0,
          programa_fertilizacion_id  : null,
          programa                   : [], //??
          real                       : [], //??

          //datos de frontend
          isNew       : true,
          vinedoId    : vinedoId,
          sectores    : [],
          productos   : [],
        };





        menu.getSidebarProm()
          .then(() => temporadaFac.getTemporadas(true, { vinedo_id: vinedoId }))
          .then(res => {
            vm.temporadas = res.data.data;
            vm.temporadaSelected = _.find(vm.temporadas, {activo:true});
          })
          .then(() => {
            vm.equipos = global.getSidebarData(vinedoId).equipos;
            vm.getDataProgramaFert();
          });






        vm.getDataProgramaFert = function(){
          vm.loading = true;
          $http({
            url    : urls.BASE + "/fertilizacion/vinedo",
            params : {
              vinedo_id : $stateParams.id,
              periodo   : vm.temporadaSelected.periodo,
            }
          }).then(function(res){
            vm.loading   = false;
            vm.productos = res.data.data.productos;
            vm.programas = _.map(res.data.data.programas_fertilizacion, programa => {

              var etapasGlobal = [];
              if(programa.sectores){
                programa.sectores.forEach(sector => {
                  if(sector.programas){
                    sector.etapas = sector.etapas || [];

                    sector.programas.forEach(etapa => {

                      sector.etapas.push({
                        ...etapa,
                        fechaInicio : etapa.fecha_inicio,
                        fechaFin    : etapa.fecha_fin,
                        productos   : etapa.programa.map( prog => {
                          let producto = _.find(vm.productos, {id: prog.producto_id});
                          let real = _.find(etapa.real , {producto_id: prog.producto_id});
                          if(real){
                            delete real.producto_id;
                          }
                          return {
                            ...producto,
                            ...real,
                            value: prog.cantidad
                          }
                        })
                      });

                      if(!_.find(etapasGlobal, {
                        fechaInicio : etapa.fecha_inicio,
                        fechaFin    : etapa.fecha_fin,
                        nombre      : etapa.nombre
                      })){
                        let etapaGlobal = {
                          ...etapa,
                          fechaInicio : etapa.fecha_inicio,
                          fechaFin    : etapa.fecha_fin,
                          productos   : etapa.programa.map( prog => {
                            let producto = _.find(vm.productos, {id: prog.producto_id});
                            return {
                              ...producto,
                              value: prog.cantidad
                            }
                          })
                        } ;
                        delete etapaGlobal.id;
                        etapasGlobal.push(etapaGlobal);
                      }


                    });
                  }
                });
              }


              return {
                id                : programa.id,
                nombre            : programa.nombre,
                fechaInicio       : programa.fecha_inicio,
                fechaFin          : programa.fecha_fin,
                sectores_riego_id : programa.sectores.map(sector => sector.id),
                vinedoId          : vinedoId,

                //para uso en frontend
                sectores          : programa.sectores,
                etapas            : etapasGlobal// para usar en header de tabla
              }
            });
            if(vm.programas.length > 0){
              vm.programas = _.sortBy(vm.programas, "id");
              vm.selectPrograma(_.first(vm.programas));
            }
          })
        }



        vm.addNewPrograma = function(ev){
          if(_.find(vm.programas, {isNew: true}))  return;

          var programa = _.clone(newProgramaTemplate);
          vm.programas.push(programa);
          vm.selectPrograma(programa);
        }


        vm.editEtapa = function(ev, etapaEdit){
          vm.showDialogEditEtapa (ev, etapaEdit)
            .then(newEtapaEdited => {

              etapaEdit.nombre      = newEtapaEdited.nombre;
              etapaEdit.fechaInicio = newEtapaEdited.fechaInicio;
              etapaEdit.fechaFin    = newEtapaEdited.fechaFin;

              etapaEdit.productos   = newEtapaEdited.productos.map(prod => {
                let productoOriginal = _.find( etapaEdit.productos, {id: prod.id});
                return {
                  ...prod,
                  value: productoOriginal ? productoOriginal.value : 0
                }
              });

              vm.programaSelected.sectores.forEach(sector => {
                sector.etapas.forEach(etapa => {
                  if(vm.isSameEtapa(etapa, etapaEdit)){
                    etapa.productos   = newEtapaEdited.productos.map(prod => {
                      let productoOriginal = _.find(etapa.productos, {id: prod.id});
                      return {
                        ...prod,
                        value: productoOriginal ? productoOriginal.value : 0
                      }
                    });
                  }

                });
              });

            }, resError => {

            });
        }



        vm.addNewEtapa = function(ev){
          var newEtapa = _.clone(newEtapaTemplate);
          newEtapa.productos = _.clone(vm.productos);

          vm.showDialogEditEtapa (ev, newEtapa)
            .then(newEtapaEdited => {

            if(vm.programaSelected.etapas == undefined){
              vm.programaSelected.etapas = [];
            }
            vm.programaSelected.etapas.push(newEtapaEdited);

            vm.programaSelected.sectores.map(sector => {
              var newEtapaSector = _.cloneDeep(newEtapaEdited);

              newEtapaSector.productos = newEtapaSector.productos.map(producto => {
                return {
                  ...producto,
                  value : 0
                }
              });

              sector.etapas.push(newEtapaSector);
            });
          }, ()=>{

          });

        }


        vm.deletePrograma = function(programa){
          if(confirm("¿Seguro desea eliminar este programa?")){
            vm.loading = true;
            $http({
              method:"DELETE",
              url    : urls.BASE + "/fertilizacion/programa-fertilizacion",
              params : {
                id:programa.id
              }
            }).then(function(res){
              vm.loading   = false;
              const index = vm.programas.indexOf(programa);
              if (index > -1) {
                vm.programas.splice(index, 1);
              }
              if(programa == vm.programaSelected){
                vm.selectPrograma(_.first(vm.programas));
              }
            });
          }
        }


        vm.deleteEtapa = function(etapaToDelete){
          if(confirm("¿Seguro desea eliminar esta etapa?")){
            vm.loading = true;
            let promises = [];

            vm.programaSelected.sectores.forEach(sector => {
              
              const index = _.findIndex(sector.etapas, etapa => {
                return vm.isSameEtapa(etapa, etapaToDelete);
              });

              if (index > -1) {

                let etapaSectorToDelete = sector.etapas[index];

                let prom = $http({
                  method:"DELETE",
                  url    : urls.BASE + "/fertilizacion/programa",
                  params : {
                    id: etapaSectorToDelete.id
                  }
                });
                prom.then(function(res){
                  const index = _.findIndex(vm.programaSelected.etapas, etapa => vm.isSameEtapa(etapa, etapaToDelete));
                  if (index > -1) {
                    vm.programaSelected.etapas.splice(index, 1);
                  }

                  sector.etapas.splice(index, 1);

                });

              }
            });


            let thenFn = function(){
              vm.loading   = false;
              const index = _.findIndex(vm.programaSelected.etapas, etapa => {
                return etapa.id == etapaToDelete.id;
              });
              if (index > -1) {
                vm.programaSelected.etapas.splice(index, 1);
              }
              vm.saveProgramaFert(vm.programaSelected);
            }


            if(promises.length > 0){
              Promise.all(promises).then(thenFn);
            }else{
              thenFn();
            }


          }
        }


        vm.deleteSector = function(sectorToDelete){

          if(confirm("¿Seguro desea eliminar este sector?")){
            vm.loading = true;
            let promises = [];

            vm.programaSelected.sectores.forEach(sector => {
              if(sector.id == sectorToDelete.id){
                sector.etapas.forEach(etapa => {
                  if(etapa.id){
                    let prom = $http({
                      method:"DELETE",
                      url    : urls.BASE + "/fertilizacion/programa",
                      params : {
                        id:etapa.id
                      }
                    })
                    promises.push(prom);
                  }
                });
              }
            });

            let thenFn = function(){
              vm.loading   = false;
              const index = _.findIndex(vm.programaSelected.sectores, sector => {
                return sector.id == sectorToDelete.id;
              });
              if (index > -1) {
                vm.programaSelected.sectores.splice(index, 1);
              }
              vm.saveProgramaFert(vm.programaSelected);
            }


            if(promises.length > 0){
              Promise.all(promises).then(thenFn);
            }else{
              thenFn();
            }
          }
        }



        vm.selectPrograma = function(programa){
          vm.programaSelected = programa;
        }


        vm.selectSectoresCallback = function(dataDialog){
          var sectoresSeleccionados = dataDialog.seleccionados.map(sector => {
            let etapas = _.cloneDeep(vm.programaSelected.etapas);
            return {
              id     : sector.id,
              ha     : sector.ha,
              nombre : sector.nombre,
              etapas : etapas || [],
            }
          });
          vm.programaSelected.sectores = _.uniqBy(vm.programaSelected.sectores.concat(sectoresSeleccionados ), "id");
        }


        vm.saveProgramaFert = function(programa){
          vm.loading = true;
          var data = {
            nombre            : programa.nombre,
            fecha_inicio      : programa.fechaInicio,
            fecha_fin         : programa.fechaFin,
            vinedo_id         : programa.vinedoId,
            sectores_riego_id : programa.sectores.map(sector => sector.id),
          };

          if(programa.id){
            data.id = programa.id;
          }

          $http({
            method : "POST",
            url    : urls.BASE + "/fertilizacion/programa-fertilizacion",
            data   : data
          }).then(res => {
            vm.loading   = false;

            if(programa.isNew){
              programa.isNew = false;
            }

            if(!programa.id){
              programa.id = parseInt(res.data.id);
            }

            programa.sectores.forEach(sector => {
              sector.etapas.forEach(etapa => {
                vm.saveEtapaProgramFert(programa, sector, etapa);
              });
            });

          })
        }


        vm.saveEtapaProgramFert = function(programa, sector, etapa){
          vm.loading   = true;

          var data = {
            programa_fertilizacion_id : programa.id,
            nombre                    : etapa.nombre,
            fecha_inicio              : etapa.fechaInicio,
            fecha_fin                 : etapa.fechaFin,
            vinedo_id                 : etapa.vinedoId,
            sector_riego_id           : [ sector.id ], //etapa.sectores.map(sector => sector.id),
            productos                 : etapa.productos.map(producto => ({
              id       : producto.id,
              unidades : producto.value || 0
            }))
          };

          if(etapa.id){
            data.id = etapa.id;
          }

          $http({
            method : "POST",
            url    : urls.BASE + "/fertilizacion/programa",
            data   : data
          }).then(res => {

            vm.loading  = false;
            etapa.isNew = false;

            if(!etapa.id){
              etapa.id = parseInt(res.data.id);
            }

          })
        }


        vm.changeInput = function(sector, etapa, producto){

        }







        vm.showDialogEditEtapa = (ev, etapa) => {
          var parent = document.getElementsByClassName('md-dialog-container')[0];
          
          if(parent == null){
            parent = angular.element(document.body);
          }

          var prom = $mdDialog.show({
            controller:['$mdDialog', 'etapa', 'productos', function($mdDialog, etapa, productos){
              var vm = this;
              vm.etapaEditable = _.clone(etapa);
              vm.productos = productos;

              vm.cancel = ()=>{
                $mdDialog.cancel();
              }

              vm.save = ()=>{
                $mdDialog.hide(vm.etapaEditable);
              }

            }],
            controllerAs        : "ep",
            templateUrl         : 'components/vinedo/newtimeline/programaFert/editEtapaProgramaFert.tmpl.html',
            parent              : parent,
            targetEvent         : ev,
            clickOutsideToClose : false,
            multiple: true,
            locals              : {
              etapa     : etapa,
              productos : vm.productos
            }
          });
          return prom;
        };


        vm.isSameEtapa = function(etapaA, etapaB){
          return  etapaA.nombre      == etapaB.nombre &&
                  etapaA.fechaInicio == etapaB.fechaInicio &&
                  etapaA.fechaFin    == etapaB.fechaFin;
        }

        vm.close = () => {
          $mdDialog.cancel();
        }


      }]
);

})();
